import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, Star } from "lucide-react";
import { API } from "@/lib/api";
import { LOGO_URL } from "@/lib/brand";
import { TalentCardView } from "@/components/TalentCardView";

export default function RosterPage() {
  const { token } = useParams();
  const [cards, setCards] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/roster/${token}`)
      .then(({ data }) => setCards(data.cards))
      .catch((e) => setError(e.response?.status === 410 ? "This roster link has expired." : "This roster could not be found."));
  }, [token]);

  if (error) return (
    <div className="min-h-screen bg-[#050505] text-white flex flex-col items-center justify-center px-6 text-center" data-testid="roster-error">
      <img src={LOGO_URL} alt="Splash Creative Hub" className="w-[150px] h-auto object-contain mb-8" />
      <p className="text-sm text-[#A1A1AA]">{error}</p>
    </div>
  );

  if (!cards) return <div className="min-h-screen bg-[#050505] flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#FF4D00]" /></div>;

  return (
    <div className="min-h-screen bg-[#050505] text-white pro-stage-bg">
      <header className="border-b border-white/10">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
          <img src={LOGO_URL} alt="Splash Creative Hub" className="w-[140px] h-auto object-contain" />
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#A1A1AA] flex items-center gap-2"><Star className="w-3.5 h-3.5 text-[#FF4D00]" /> Talent Roster</span>
        </div>
      </header>

      <main className="max-w-[900px] mx-auto px-6 lg:px-10 py-20" data-testid="roster-page">
        <div className="mb-14">
          <div className="text-[11px] uppercase tracking-[0.4em] text-[#FF4D00] mb-4 flex items-center gap-2"><Star className="w-3.5 h-3.5" /> The Splash Team · Curated Roster</div>
          <h1 className="font-bebas text-5xl sm:text-6xl uppercase leading-[0.88] tracking-[0.05em]">HAND-PICKED FOR YOU</h1>
          <div className="name-rule mt-5" />
          <p className="text-sm text-[#A1A1AA] mt-6">{cards.length} vetted {cards.length === 1 ? "creative" : "creatives"} selected for your project.</p>
        </div>

        {cards.length === 0 ? (
          <p className="text-sm text-[#A1A1AA]" data-testid="roster-empty">No creatives in this roster.</p>
        ) : (
          <div className="space-y-10">
            {cards.map((card, i) => (
              <div key={i} data-testid={`roster-card-${i}`}>
                <TalentCardView card={card} index={i} testId={`roster-talent-${i}`} />
              </div>
            ))}
          </div>
        )}
      </main>

      <footer className="border-t border-white/10 mt-8">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-8 text-xs text-[#A1A1AA] flex items-center justify-between">
          <span className="font-bebas text-lg text-white tracking-wide">SPLASH CREATIVE HUB</span>
          <span>Presented by the Splash Team</span>
        </div>
      </footer>
    </div>
  );
}
